import { CrossIcon, IconButton } from 'evergreen-ui'
import styled from 'styled-components'

export const CloseButton = styled(IconButton).attrs({
  paddingX: 0,
  icon: CrossIcon,
  appearance: 'minimal',
})``
